/**
 * @generated SignedSource<<1894ec623dc9c5e70e9eafb88c1cfd3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedShopByModuleControl_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly items: ReadonlyArray<{
    readonly cmsId: number | null;
    readonly linkData: {
      readonly path: string | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleItem_item">;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedShopByModuleControl_componentModule";
};
export type HpSharedShopByModuleControl_componentModule$key = {
  readonly " $data"?: HpSharedShopByModuleControl_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleControl_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedShopByModuleControl_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedShopByModuleItem_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShopByModule",
  "abstractKey": null
};

(node as any).hash = "9898e64bf006675ab9326600bc91dc9c";

export default node;
